import { createSlice } from "@reduxjs/toolkit";
import { loungeService } from "../../services/loungeService";

// Agent Lounge — Redux holds ONLY the unread badge count (GATE0 §2 / Brief §3:
// "Redux nur fürs Nav-Badge"). No list, no items, no realtime — the Activity
// panel owns its own list state locally. This slice exists so the Sofa nav
// icon's badge and the in-lounge Activity button's badge read the SAME number.
// Pattern mirrors notificationsSlice (createSlice + a thunk), trimmed to one
// field.
const loungeSlice = createSlice({
  name: "lounge",
  initialState: { unreadCount: 0 },
  reducers: {
    setLoungeUnread: (state, action) => {
      state.unreadCount = Math.max(0, Number(action.payload) || 0);
    },
  },
});

export const { setLoungeUnread } = loungeSlice.actions;

// Fetch the badge number only (page 1 of activity → unread_count). Gated by
// the caller to agent members so non-members never trigger a 403.
export const fetchLoungeUnread = () => async (dispatch) => {
  const res = await loungeService.getActivity(1);
  if (res.success) dispatch(setLoungeUnread(res.unreadCount));
};

export default loungeSlice.reducer;
